import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from './../Common/Header';
import Footer from './../Common/Footer';

import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/s4/b2.jpg');

class Services_4 extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content ">
                    <Banner
                        title="Control Climate. Command Comfort. Commit to Efficiency."
                        pagename="HVAC (Heating, Ventilation, and Air Conditioning)"
                        bgimage={bnrimg}
                    />

                    <div className="section-full p-tb80 inner-page-padding">
                        <div className="container">
                            <div className="blog-single-wrap-width">
                                <div className="blog-post date-style-3 blog-detail text-black">
                                    <div className="mt-post-media clearfix m-b30">
                                        <ul className="grid-post">
                                            <li>
                                                <div className="portfolio-item">
                                                    <img className="img-responsive" src={require("./../../images/s4/b1.jpg")} alt="HVAC System" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="mt-post-title ">
                                        <h3 className="post-title font-weight-600">
                                            HVAC (Heating, Ventilation, and Air Conditioning)
                                        </h3>
                                    </div>

                                    <div className="mt-post-text">
                                        <p><strong>"Comfort is operational readiness. Clean air is mission-critical."</strong></p>

                                        <p>
                                            At <strong>I-Smart Engineering Works</strong>, we bring climate control with military-grade precision. Our HVAC systems go beyond heating and cooling — they support health, performance, and energy efficiency for modern infrastructure.
                                        </p>

                                        <p>
                                            Whether you're outfitting an office, hospital, mall, or a sensitive technical zone, we design, install, and maintain HVAC systems engineered to meet exacting standards. When the mission is comfort without compromise, we deliver.
                                        </p>

                                        <h4 className="font-weight-600">Our HVAC Services Include:</h4>
                                        <ul className="list-angle-right">
                                            <li>Central & Split AC system installation</li>
                                            <li>Industrial ventilation layout & ducting</li>
                                            <li>Cleanroom & sterile air environment systems</li>
                                            <li>High-efficiency retrofits and AMC servicing</li>
                                            <li>Smart climate control integration with BMS</li>
                                        </ul>

                                        <blockquote className="bg-dark text-white author-quote">
                                            <h4 className="m-b0">
                                                “Onboard our ships, air control is the first line of defense — same goes for buildings. HVAC is not luxury, it’s life support.” <i className="fa fa-quote-right" />
                                            </h4>
                                            <div className="p-t15 text-white">
                                                <strong className="text-primary">Chief Petty Officer Derek M.</strong>
                                                <span>U.S. Navy Facilities Specialist</span>
                                            </div>
                                        </blockquote>

                                        <p>
                                            Our service philosophy blends speed, cleanliness, and zero-disruption. We deploy experienced technicians, use clean installation methods, and always leave the site mission-ready.
                                        </p>

                                        {/* <div className="row">
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog.jpg")} alt="Ducting Work" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog2.jpg")} alt="Air Conditioning Unit" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-4 col-sm-4">
                                                <div className="mt-box m-b30">
                                                    <div className="mt-media">
                                                        <img src={require("./../../images/blog/large-blog3.jpg")} alt="HVAC Maintenance" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}

                                        <p>
                                            <strong>Looking to optimize indoor air quality and energy efficiency?</strong> Call us for a custom HVAC survey and deployment roadmap.
                                        </p>
                                    </div>

                                    <div className="autor-post-tag-share bdr-t-1 bdr-solid bdr-gray p-t20">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6">
                                                <div className="widget widget_tag_cloud">
                                                    <h4 className="tagcloud">Tags</h4>
                                                    <div className="tagcloud">
                                                        <NavLink to={"#"}>HVAC</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Ventilation</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Clean Room</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Energy Efficiency</NavLink>&nbsp;
                                                        <NavLink to={"#"}>Facility Management</NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </>
        );
    };
};

export default Services_4;
